(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["maxtra-localization"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('maxtra-localization')) {
    customElements.define('maxtra-localization', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        const dialog = this.querySelector('dialog');
        const trigger = this.querySelector('[data-mx-open]');
        const search = this.querySelector('[data-mx-search]');
        const rows = [...this.querySelectorAll('[data-mx-country]')];
        const normalize = text => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase();
        trigger.addEventListener('click', () => {
          dialog.showModal(); trigger.setAttribute('aria-expanded', 'true'); search.focus();
        });
        this.querySelector('[data-mx-close]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if(event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
        dialog.addEventListener('close', () => { trigger.setAttribute('aria-expanded', 'false'); trigger.focus(); });
        const filterCountries = () => {
          const query = normalize(search.value.trim());
          let visible = 0;
          rows.forEach(row => { row.hidden = !normalize(row.dataset.mxCountry).includes(query); if (!row.hidden) visible++; });
          this.querySelector('[data-mx-empty]').hidden = visible > 0;
        };
        search.addEventListener('input', filterCountries);
        filterCountries();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ns-arnowa-product"] && !Shopify.designMode) return;
  try {
    function initializeArnowaTabs() {
    document.querySelectorAll('[data-ns-arnowa-tabs]').forEach((root) => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const buttons = Array.from(root.querySelectorAll('[data-tab]'));
      const panels = root.querySelectorAll('[data-panel]');
      function activate(button) {
        buttons.forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
        });
        panels.forEach((panel) => {
          const active = panel.dataset.panel === button.dataset.tab;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
      }
      buttons.forEach((button, index) => {
        button.addEventListener('click', () => activate(button));
        button.addEventListener('keydown', (event) => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + buttons.length) % buttons.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = buttons.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          activate(buttons[next]);
          buttons[next].focus();
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeArnowaTabs);
  else initializeArnowaTabs();
  document.addEventListener('shopify:section:load', initializeArnowaTabs);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ns-ean-field"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ns-ean-field')) {
    let eanDraft = null;
    customElements.define('ns-ean-field', class extends HTMLElement {
      connectedCallback() {
        if (this.eanBound) return;
        const input = this.querySelector('input');
        const error = this.querySelector('.ns-ean__error');
        if (!input || !error) return;
        this.eanBound = true;
        if (eanDraft !== null) input.value = eanDraft;
        const validate = (showError) => {
          const valid = input.value === '' || /^[0-9]{13}$/.test(input.value);
          input.setCustomValidity(valid ? '' : this.dataset.error);
          input.setAttribute('aria-invalid', String(!valid));
          error.hidden = valid || !showError;
          error.textContent = valid ? '' : this.dataset.error;
          return valid;
        };
        input.addEventListener('input', () => {
          input.value = input.value.replace(/[\s-]/g, '');
          eanDraft = input.value;
          validate(false);
        });
        input.addEventListener('blur', () => validate(true));
        input.addEventListener('invalid', () => validate(true));
        validate(false);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
